<template>
  <div
    class="mobile-header d-flex flex-row align-items-center justify-content-space-between i-p-16"
  >
    <logo-component
      :is-mobile="false"
      :color="palette['logo-rich-black']"
      height="21px"
    />
    <i-icon-button
      class="remove"
      symbol="medium-hamburger"
      size="md"
      type="transparent"
      @button-click="toggleLeftNav()"
    ></i-icon-button>
  </div>
</template>

<script>
import LogoComponent from '../Logo';
import palette from '@inscribe/signal/dist/palette';
import { iIconButton } from '@inscribe/signal';

export default {
  components: { iIconButton, LogoComponent },
  props: {},
  data: () => ({
    menuOpen: false,
    palette,
  }),
  computed: {},
  methods: {
    toggleLeftNav() {
      this.$emit('toggle-left-nav');
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-header {
  background: $light-neutral-default;
  height: 56px;
  width: 100%;
  justify-content: space-between;
}
</style>
